module.exports = __webpack_public_path__ + "img/vegetable-mustard-greens-350x184.5076f7e9.jpg";